import { resolveLoginCompany } from '../../utils/loginCompany';

export const DEFAULT_QUOTATION_TERMS = {
  price: 'The above rate/unit is (are) inclusive of all GST, Transportation and pumping Charges.',
  delivery: 'F.O.R. Destination. If the order Qty. is less than 24 m3, Rs.10000/- per pour will be charged extra towards Pump.',
  payment: 'Advance',
};

export function getInitialQuotationFormState() {
  return {
    show_total_in_pdf: 'true',
    company_id: '',
    customer_id: '',
    consignee_id: '',
    enquiry_no: '',
    enquiry_date: '',
    is_tax_included: 'true',
    terms_condition: '',
    quotation_no: '',
    quotation_date: '',
    prefix: '',
    prod_category: '',
    status: 'true',
    kind_attention: '',
    designation: '',
    price: DEFAULT_QUOTATION_TERMS.price,
    delivery: DEFAULT_QUOTATION_TERMS.delivery,
    payment: DEFAULT_QUOTATION_TERMS.payment,
  };
}

export function pickDefaultCompanyId(companyList) {
  const adapted = (companyList || []).map((company) => ({
    ...company,
    name: company.entity_name || company.name,
  }));
  const match = resolveLoginCompany(adapted);
  return match ? String(match.id) : '';
}

export function applyCustomerAttentionDefaults(customer) {
  if (!customer?.id) {
    return { kind_attention: '', designation: '' };
  }
  return {
    kind_attention: customer.contact_person || '',
    designation: customer.contact_designation || '',
  };
}
